import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getWAREHOUSESTATIONSTableStructure";
export const UPDATE_TABLE_DATA = "updateWAREHOUSESTATIONSTableData";
export const EXPORT_TABLE_DATA = "exportWAREHOUSESTATIONSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setWAREHOUSESTATIONSTableStructure";
export const SET_TABLE_DATA = "setWAREHOUSESTATIONSTableData";
export const SET_TABLE_PAGE = "setWAREHOUSESTATIONSTablePage";
export const SET_TABLE_PERPAGE = "setWAREHOUSESTATIONSTablePerPage";
export const SET_TABLE_FILTER = "setWAREHOUSESTATIONSTableFilter";
export const SET_EXPORT_LINK = "setWAREHOUSESTATIONSExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getWAREHOUSESTATIONSTableProperties(state) {
    return state.table_structure.properties;
  },
  getWAREHOUSESTATIONSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getWAREHOUSESTATIONSTableState(state) {
    return state.table_state;
  },
  getWAREHOUSESTATIONSTableData(state) {
    return state.table_data.data;
  },
  getWAREHOUSESTATIONSTableHeaders(state) {
    return state.table_structure.columns;
  },
  getWAREHOUSESTATIONSTableFilters(state) {
    return state.table_structure.filters;
  },
  getWAREHOUSESTATIONSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/warehouse_stations")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/warehouse_stations/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/warehouse_stations/export",
        payload
      )
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
